import { render, staticRenderFns } from "./ReceiveMailDetail.vue?vue&type=template&id=d6231dea&scoped=true"
import script from "./ReceiveMailDetail.vue?vue&type=script&lang=js"
export * from "./ReceiveMailDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiveMailDetail.vue?vue&type=style&index=0&id=d6231dea&prod&lang=scss"
import style1 from "./ReceiveMailDetail.vue?vue&type=style&index=1&id=d6231dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6231dea",
  null
  
)

export default component.exports